/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Daily_Task_Focus_TimesInputs */

const en_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Plant any tree 1 time`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Plant any tree ${i?.number} times`);
	return /** @type {LocalizedString} */ (`Plant any tree ${i?.number} times`)
	
};

const ar_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`ازرع أي شجرة 0 مرة`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`ازرع أي شجرة مرة واحدة`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`ازرع أي شجرة مرتين`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`ازرع أي شجرة ${i?.number} مرات`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`ازرع أي شجرة ${i?.number} مرة`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`ازرع أي شجرة ${i?.number} مرة`);
	return /** @type {LocalizedString} */ (`ازرع أي شجرة ${i?.number} مرة`)
	
};

const de_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Pflanze einen beliebigen Baum 1 Mal`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Pflanze einen beliebigen Baum ${i?.number} Mal`);
	return /** @type {LocalizedString} */ (`Pflanze einen beliebigen Baum ${i?.number} Mal`)
	
};

const es_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Planta cualquier árbol 1 vez`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Planta cualquier árbol ${i?.number} veces`);
	return /** @type {LocalizedString} */ (`Planta cualquier árbol ${i?.number} veces`)
	
};

const fr_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Planter n'importe quel arbre ${i?.number} fois`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Planter n'importe quel arbre ${i?.number} fois`);
	return /** @type {LocalizedString} */ (`Planter n'importe quel arbre ${i?.number} fois`)
	
};

const it_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Pianta un albero qualsiasi 1 volta`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Pianta un albero qualsiasi ${i?.number} volte`);
	return /** @type {LocalizedString} */ (`Pianta un albero qualsiasi ${i?.number} volte`)
	
};

const ja_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`好きな木を${i?.number}回植える`);
	return /** @type {LocalizedString} */ (`好きな木を${i?.number}回植える`)
	
};

const ko_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`아무 나무 ${i?.number}회 심기`);
	return /** @type {LocalizedString} */ (`아무 나무 ${i?.number}회 심기`)
	
};

const pt_br_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Plante qualquer árvore ${i?.number} vez`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Plante qualquer árvore ${i?.number} vezes`);
	return /** @type {LocalizedString} */ (`Plante qualquer árvore ${i?.number} vezes`)
	
};

const ru_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Посади любое дерево ${i?.number} раз`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`Посади любое дерево ${i?.number} раза`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`Посади любое дерево ${i?.number} раз`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Посади любое дерево ${i?.number} раза`);
	return /** @type {LocalizedString} */ (`Посади любое дерево ${i?.number} раза`)
	
};

const th_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`ปลูกต้นไม้ใด ๆ ${i?.number} ครั้ง`);
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ใด ๆ ${i?.number} ครั้ง`)
	
};

const tr_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`1 kez herhangi bir ağaç dik`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} kez herhangi bir ağaç dik`);
	return /** @type {LocalizedString} */ (`${i?.number} kez herhangi bir ağaç dik`)
	
};

const zh_cn_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`种植任意树种 ${i?.number} 次`);
	return /** @type {LocalizedString} */ (`种植任意树种 ${i?.number} 次`)
	
};

const zh_tw_daily_task_focus_times = /** @type {(inputs: Daily_Task_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`種植任意樹種 ${i?.number} 次`);
	return /** @type {LocalizedString} */ (`種植任意樹種 ${i?.number} 次`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "Plant any tree 1 time" |
* | "other" | "Plant any tree {number} times" |
* | * | "Plant any tree {number} times" |
*
* @param {Daily_Task_Focus_TimesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_task_focus_times = /** @type {((inputs: Daily_Task_Focus_TimesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Task_Focus_TimesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_task_focus_times(inputs)
	if (locale === "ar") return ar_daily_task_focus_times(inputs)
	if (locale === "de") return de_daily_task_focus_times(inputs)
	if (locale === "es") return es_daily_task_focus_times(inputs)
	if (locale === "fr") return fr_daily_task_focus_times(inputs)
	if (locale === "it") return it_daily_task_focus_times(inputs)
	if (locale === "ja") return ja_daily_task_focus_times(inputs)
	if (locale === "ko") return ko_daily_task_focus_times(inputs)
	if (locale === "pt_br") return pt_br_daily_task_focus_times(inputs)
	if (locale === "ru") return ru_daily_task_focus_times(inputs)
	if (locale === "th") return th_daily_task_focus_times(inputs)
	if (locale === "tr") return tr_daily_task_focus_times(inputs)
	if (locale === "zh_cn") return zh_cn_daily_task_focus_times(inputs)
	return zh_tw_daily_task_focus_times(inputs)
});